import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export function clear(): BaseTockAction {
  return {
    type: AppConstants.SELECTION_SET,
    payload: {},
  };
}

export function selectTicketType(ticketTypeId: number): BaseTockAction {
  return {
    type: AppConstants.SELECTION_SET,
    payload: {
      ticketTypeId,
      ticketTypePackageId: null,
    },
  };
}

export function changeTicketType(ticketTypeId: number): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      ticketTypeId,
    },
  };
}

export function selectSize(size: number): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      size,
    },
  };
}

export function selectDate(date: string): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      date,
    },
  };
}

export function selectTime(time: string): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      time,
    },
  };
}

export function selectCard(card: Partial<core.IPaymentCard> | null): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      card,
    },
  };
}

export function clearCard(): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      card: null,
    },
  };
}

export function selectBasePurchaseId(basePurchaseId: number | null): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      basePurchaseId,
    },
  };
}

export function selectOptions(options: core.IOptionOrder[] | null): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      options,
    },
  };
}

export function selectOriginalOptions(originalOptions: core.IOptionOrder[] | null): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      originalOptions,
    },
  };
}

export function setPurchaseVerifyToken(purchaseVerifyToken: string): BaseTockAction {
  return {
    type: AppConstants.SELECTION_SET,
    payload: {
      purchaseVerifyToken,
    },
  };
}

export function setTransferPurchaseToken(transferPurchaseToken: string): BaseTockAction {
  return {
    type: AppConstants.SELECTION_SET,
    payload: {
      transferPurchaseToken,
    },
  };
}

export function setVisitEditToken(visitEditToken: string): BaseTockAction {
  return {
    type: AppConstants.SELECTION_SET,
    payload: {
      visitEditToken,
    },
  };
}

export function setVisitEditPaymentMode(visitEditPaymentMode: boolean): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      visitEditPaymentMode,
    },
  };
}

export function setCheckoutFlowOrigin(origin: 'TABLESIDE' | 'TABLESIDE_QR_TABLE'): BaseTockAction {
  return {
    type: AppConstants.SELECTION_UPDATE,
    payload: {
      checkoutFlowOrigin: origin,
    },
  };
}
